document.addEventListener("DOMContentLoaded", function() {
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
//customers are able to purchase coming soon products for some reason, so we will delay this for 20 seconds.
sleep(2000);
  
SetButton();
  
//display button.
window.addEventListener('load', function() {
 var elements = document.getElementsByClassName("hk-add-to-cart-button");
 for (var i = 0; i < elements.length; i++) {
     elements[i].style.display = "block";
  }
}); 
  
function SetButton(){
  if(isDigital.toLowerCase()=="true" && pdctStatus.toLowerCase()!='10 published')
  {
      $("button[name='add']").prop("disabled",true).text("Coming Soon");
      return false;
  }
  if(isDigital.toLowerCase()!="true" && pdctStatus.toLowerCase()!='10 published')
  {
     $("button[name='add']").prop("disabled",true).text("Coming Soon");
     return false;
  }
  if(isDigital.toLowerCase() !="true")
  {
    if(parseInt(quantity)<=5)
    {
       $("button[name='add']").prop("disabled",true).text("Sold Out");
       return false;
    }
  }

  //the product is available if we get here so, set to add to cart and enable button.
   $("button[name='add']").prop("enabled",true).text("Add to Cart");

  //Back in stock app doesn't have a way of tracking digital products.
  //Coming soon products don't have weight and we need to display the button so, 
  //we enable the option to track all the products on the app
  //and then we hide it here for available products (products are available if we get here!)
  
  //This null check prevents a JavaScript runtime error that causes add to cart missing
  var bis = document.getElementById("BIS_trigger");
  if (bis) {
    bis.style.display = "none";
  }
}
});